
import { Alert, AlertDescription } from '@/components/ui/alert';
import { CheckCircle2 } from 'lucide-react';

interface VerificationStatusProps {
  type: 'email' | 'phone';
  verified: boolean;
}

export const VerificationStatus = ({ type, verified }: VerificationStatusProps) => {
  if (!verified) return null;
  
  return (
    <Alert className="bg-green-50 border-green-200">
      <CheckCircle2 className="h-4 w-4 text-green-500 mr-2" />
      <AlertDescription className="text-green-600 flex items-center">
        {type === 'email' ? 'Email' : 'Phone'} successfully verified!
      </AlertDescription>
    </Alert>
  );
};
